import React from "react";
import styles from "./Dropdown.module.scss";
import cx from "classnames";
import useDocumentClick from "@hooks/useDocumentClick";
import _ from "lodash";

const View = React.forwardRef(
  (
    {
      className,
      itemProps = {},
      optionProps = {},
      value,
      placeholder = "Select",
      onChange,
      onToggle,
      onBlur,
      options,
    }: any,
    _ref: any
  ) => {
    const currentRef: any = React.useRef({});

    const handler = {
      toggle: () => {
        if (currentRef && currentRef.current) {
          if (currentRef.current.classList.contains(styles.active)) {
            currentRef.current.classList.remove(styles.active);
            _.isFunction(onToggle) ? onToggle(false) : null;
          } else {
            currentRef.current.classList.add(styles.active);
            _.isFunction(onToggle) ? onToggle(true) : null;
          }
        }
      },

      handleClickOutside: (event: any) => {
        if (
          currentRef &&
          currentRef.current &&
          !currentRef.current.contains(event.target)
        ) {
          _.isFunction(onBlur) ? onBlur() : null;
          if (currentRef.current.classList.contains(styles.active))
            currentRef.current.classList.remove(styles.active);
        }
      },

      onBlur: () => {
        if (
          currentRef &&
          currentRef.current.classList.contains(styles.active)
        ) {
          _.isFunction(onBlur) ? onBlur() : null;
          currentRef.current.classList.remove(styles.active);
        }
      },
    };
    useDocumentClick(handler.handleClickOutside);
    const labelCurrent = React.useMemo(
      () =>
        _.get(
          _.find(options, (opt) => opt.value === value),
          "label",
          ""
        ),
      [value, options]
    );
    return (
      <div
        ref={currentRef}
        className={cx(styles.dropdown, className)}
        onClick={handler.toggle}
        onBlur={handler.onBlur}
      >
        <div
          {...itemProps}
          className={cx(styles.currentItem, itemProps.className)}
        >
          {!!(placeholder && !labelCurrent) && (
            <label className={styles.labelPlaceholder}>{placeholder}</label>
          )}
          {!!labelCurrent && (
            <label className={styles.labelValue}>{labelCurrent}</label>
          )}
        </div>
        <div
          {...optionProps}
          className={cx(styles.options, optionProps.className)}
        >
          {_.map(options, (option: any, index: number) => {
            return (
              <div
                key={`option_${index}`}
                className={cx(styles.option, {
                  [styles.optionSelected]: value === option.value,
                })}
                onClick={() => onChange(option)}
              >
                <label>{option.label}</label>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
);

View.displayName = "Dropdown";

export default View;
